import { Injectable, Signal, signal, WritableSignal } from '@angular/core';

export interface Header {
  showSearch?: boolean;
  showBackBtn?: boolean;
  titleKey: string;
}

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private readonly toggleMobileMenuSignal: WritableSignal<boolean> = signal(null);
  public toggleMobileMenu: Signal<boolean> = this.toggleMobileMenuSignal.asReadonly();

  public setMobileMenuBtn(value: boolean) {
    this.toggleMobileMenuSignal.set(value);
  }
}
